import { Col, Flex, Row } from "antd";
import React, { useState } from "react";
import CustomHeader from "../../components/header/CustomHeader";
import { IconArrowNarrowRight } from "@tabler/icons-react";
import CustomModal from "../../components/modal/CustomModal";
import { downloadLotteryCSV } from "./excel/LotteryReport";
import api from "../../api";
import { useToast } from "../../components/toast/toast";
import ReportTicket from "./report-ticket";

const Report = () => {
  const [open, setOpen] = useState(false);
  const [modalType, setModalType] = useState(null); // "lottery" | "award"
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();

  const cellStyle = {
    background: "#f5f5f5",
    padding: "24px",
    borderRadius: 8,
    border: "1px solid #e0e0e0",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    transition: "0.2s",
  };

  const openModal = (type) => {
    setModalType(type);
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
    setModalType(null);
  };

  const handleDownload = async () => {
    setIsLoading(true);
    if (modalType === "lottery") {
      const res = await api.report_lottery();
      // console.log("report_lottery res --->", res);
      if (res?.status === 200) {
        await downloadLotteryCSV(res.data);
        toast("Сугалааны тайлан татагдлаа", "success");
      } else {
        toast(res.data?.message || "Алдаа гарлаа", "error");
      }
    }
    setIsLoading(false);
    closeModal();
  };

  return (
    <Flex vertical>
      <CustomHeader title={"Тайлан"} />
      <Row gutter={[16, 16]} style={{ width: "100%" }}>
        <Col xs={24} sm={12} md={6}>
          <div
            style={cellStyle}
            onClick={() => openModal("lottery")}
            role="button"
            tabIndex={0}
          >
            <h4 style={{ margin: 0 }}>Сугалааны товч тайлан татах</h4>
            <IconArrowNarrowRight size={22} />
          </div>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <ReportTicket />
        </Col>
        {/* <Col xs={24} sm={12} md={8}>
          <div
            style={cellStyle}
            onClick={() => openModal("award")}
            role="button"
            tabIndex={0}
          >
            <h4 style={{ margin: 0 }}>Шагналын тайлан татах</h4>
            <IconArrowNarrowRight size={22} />
          </div>
        </Col> */}
      </Row>

      <CustomModal
        open={open}
        title={
          modalType === "lottery" ? "Сугалааны товч тайлан" : "Шагналын тайлан"
        }
        onCancel={closeModal}
        onOk={handleDownload}
        disabled={isLoading}
      >
        {modalType === "lottery" ? null : (
          <div>Энд шагналын тайлангийн шүүлтүүрүүд байрлуул.</div>
        )}
      </CustomModal>
    </Flex>
  );
};

export default Report;
